import {
  _id,
  _server_last_patch,
  _server_list,
  _server_name,
  _server_next_refresh,
  _server_supported,
  _server_version,
  _soc2
} from './assets';

// ----------------------------------------------------------------------

export const _security = {
  id: (index: number) => _id[index],
  // Projects
  server: (index: number) => _server_list[index],
  version: (index: number) => _server_version[index],
  soc2: (index: number) => _soc2[index],
  supported: (index: number) => _server_supported[index],
  next_refresh: (index: number) => _server_next_refresh[index],
  server_name: (index: number) => _server_name[index],
  last_patch: (index: number) => _server_last_patch[index]
};
